import script from "./MealPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MealPage.vue?vue&type=script&setup=true&lang=js"

import "./MealPage.vue?vue&type=style&index=0&id=f0a72e9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0a72e9c"]])

export default __exports__